import { openDB } from 'idb';

const DB_NAME = 'blob-storage-db';
const STORE_NAME = 'blobs';

let dbPromise = null;

function getDb() {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, 1, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(STORE_NAME)) {
          db.createObjectStore(STORE_NAME);
        }
      },
    });
  }
  return dbPromise;
}

/**
 * Sauvegarde un Blob (image, vidéo, audio, etc.) sous la clé donnée.
 * @param {string} key
 * @param {Blob} blob
 */
export async function saveBlob(key, blob) {
  const db = await getDb();
  const tx = db.transaction(STORE_NAME, 'readwrite');
  await tx.objectStore(STORE_NAME).put(blob, key);
  await tx.done;
}

/**
 * Récupère un Blob par clé, ou undefined si non trouvé.
 * @param {string} key
 * @returns {Promise<Blob|undefined>}
 */
export async function getBlob(key) {
  const db = await getDb();
  return await db.transaction(STORE_NAME, 'readonly').objectStore(STORE_NAME).get(key);
}

/**
 * Supprime un Blob par clé.
 * @param {string} key
 */
export async function deleteBlob(key) {
  const db = await getDb();
  const tx = db.transaction(STORE_NAME, 'readwrite');
  await tx.objectStore(STORE_NAME).delete(key);
  await tx.done;
}
